import { lazy } from 'react';

type TTableProps = {
	dataJson: string;
};

const ActiveTable = lazy(() => import('active-table-react').then(m => ({ default: m.ActiveTable })));

export function tableRenderer({ dataJson }: TTableProps) {
	let tableData: (string | number)[][] = [];

	try {
		tableData = JSON.parse(dataJson || '[]');
	} catch (err) {
		console.error('Failed to parse table data:', err);
	}

	if (!Array.isArray(tableData) || tableData.length === 0) {
		return null;
	}

	return (
		<ActiveTable
			cellStyle={{
				fontSize: '16px',
			}}
			data={tableData}
			isCellTextEditable={false}
			isHeaderTextEditable={false}
			displayAddNewRow={false}
			displayAddNewColumn={false}
			dragRows={false}
			columnDropdown={{ displaySettings: { isAvailable: false } }}
			rowDropdown={{ displaySettings: { isAvailable: false } }}
			headerStyles={{ hoverColors: { backgroundColor: 'white' } }}
			frameComponentsStyles={{ styles: { hoverColors: { backgroundColor: 'white' } } }}
			displayHeaderIcons={false}
		/>
	);
}
